//export const EXTENSION_ID = 'pboaeieplhokigfhfioicgojoncpaeim';
import i18n from 'i18next';
export interface Chrome {
  webstore?: any;
  runtime?: any;
}

declare global {
  interface Window {
    chrome?: Chrome;
  }
}

// Safely get chrome object only in browser environment
const getChrome = () => {
  if (typeof window !== 'undefined') {
    return (window as any).chrome as Chrome;
  }
  return undefined;
};

export interface ExtensionResponse {
  success: boolean;
  message: string;
}

export const handleExtensionCalls = (
  action: string
): Promise<ExtensionResponse> => {
  return new Promise((resolve) => {
    const chrome = getChrome();
    if (chrome?.runtime) {
      try {
        chrome.runtime.sendMessage(
          process.env.EXTENSION_ID,
          { action: action },
          (response) => {
            if (response) {
              resolve(response);
            } else {
              resolve({
                success: false,
                message: i18n.t('common.error-initiating-copy-from-page'),
              });
            }
          }
        );
      } catch (error) {
        resolve({
          success: false,
          message: i18n.t('common.error-sending-message-to-extension'),
        });
      }
    } else {
      resolve({
        success: false,
        message: i18n.t('common.chrome-extension-api-not-available'),
      });
    }
  });
};
